import * as React from "react"
import { useQuery } from "react-query"
import { UserEntity } from "../../lib/types/user"
import { Loading } from "../Loading"
import { ProviderProps } from "./types"

interface Affiliation {
  organization: string
  role: string
}

export const MeProvider: React.FC<ProviderProps> = ({ children }) => {
  const { data, isLoading } = useQuery<UserEntity, string>("me/", { staleTime: Infinity })
  const me = data?.email ? data : undefined

  const { data: affiliations, isLoading: affiliationsIsLoading } = useQuery<any, any>(
    `affiliations?user=${me?.uuid}`,
    { staleTime: Infinity, enabled: !!me },
  )
  if (me && affiliations && !affiliationsIsLoading) {
    me.roles = affiliations.results.map((a: Affiliation) => ({ organization: a.organization, role: a.role }))
  }

  if (isLoading && !me) return <Loading />
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>
}

export const MeContext = React.createContext<UserEntity | undefined>(undefined)

export function useMe() {
  const context = React.useContext(MeContext)
  if (!context) throw new Error("Must be called under MeProvider")
  return context
}
